import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "webform/store/store";

export const geoSliceSelector = (state: RootState) => state.geo;
export const geoCitiesSelector = createSelector(geoSliceSelector, ({cities}) => cities);
export const geoErrorSelector = createSelector(geoSliceSelector, ({error}) => error);
